module.exports = __webpack_public_path__ + "img/Con4.8197aa8b.png";